// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/caption/caption.proto (package guardianai.v1.caption, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/caption/caption.proto.
 */
export const file_guardianai_v1_caption_caption: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.caption.BusinessProfile
 */
export type BusinessProfile = Message<"guardianai.v1.caption.BusinessProfile"> & {
  /**
   * @generated from field: string brand_name = 1;
   */
  brandName: string;

  /**
   * @generated from field: string industry = 2;
   */
  industry: string;

  /**
   * @generated from field: string target_demographic = 3;
   */
  targetDemographic: string;

  /**
   * @generated from field: string brand_voice = 4;
   */
  brandVoice: string;

  /**
   * @generated from field: repeated string custom_rules = 5;
   */
  customRules: string[];

  /**
   * @generated from field: string current_goal = 6;
   */
  currentGoal: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt: string;
};

/**
 * @generated from message guardianai.v1.caption.BusinessProfile
 */
export type BusinessProfileJson = {
  /**
   * @generated from field: string brand_name = 1;
   */
  brandName?: string;

  /**
   * @generated from field: string industry = 2;
   */
  industry?: string;

  /**
   * @generated from field: string target_demographic = 3;
   */
  targetDemographic?: string;

  /**
   * @generated from field: string brand_voice = 4;
   */
  brandVoice?: string;

  /**
   * @generated from field: repeated string custom_rules = 5;
   */
  customRules?: string[];

  /**
   * @generated from field: string current_goal = 6;
   */
  currentGoal?: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.caption.BusinessProfile.
 * Use `create(BusinessProfileSchema)` to create a new message.
 */
export const BusinessProfileSchema: GenMessage<BusinessProfile, {jsonType: BusinessProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 0);

/**
 * @generated from message guardianai.v1.caption.CaptionQuotaUsage
 */
export type CaptionQuotaUsage = Message<"guardianai.v1.caption.CaptionQuotaUsage"> & {
  /**
   * @generated from field: int32 used_today = 1;
   */
  usedToday: number;

  /**
   * @generated from field: int32 daily_quota = 2;
   */
  dailyQuota: number;

  /**
   * @generated from field: int32 remaining_today = 3;
   */
  remainingToday: number;

  /**
   * @generated from field: string resets_at = 4;
   */
  resetsAt: string;
};

/**
 * @generated from message guardianai.v1.caption.CaptionQuotaUsage
 */
export type CaptionQuotaUsageJson = {
  /**
   * @generated from field: int32 used_today = 1;
   */
  usedToday?: number;

  /**
   * @generated from field: int32 daily_quota = 2;
   */
  dailyQuota?: number;

  /**
   * @generated from field: int32 remaining_today = 3;
   */
  remainingToday?: number;

  /**
   * @generated from field: string resets_at = 4;
   */
  resetsAt?: string;
};

/**
 * Describes the message guardianai.v1.caption.CaptionQuotaUsage.
 * Use `create(CaptionQuotaUsageSchema)` to create a new message.
 */
export const CaptionQuotaUsageSchema: GenMessage<CaptionQuotaUsage, {jsonType: CaptionQuotaUsageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 1);

/**
 * @generated from message guardianai.v1.caption.GetBusinessProfileRequest
 */
export type GetBusinessProfileRequest = Message<"guardianai.v1.caption.GetBusinessProfileRequest"> & {
};

/**
 * @generated from message guardianai.v1.caption.GetBusinessProfileRequest
 */
export type GetBusinessProfileRequestJson = {
};

/**
 * Describes the message guardianai.v1.caption.GetBusinessProfileRequest.
 * Use `create(GetBusinessProfileRequestSchema)` to create a new message.
 */
export const GetBusinessProfileRequestSchema: GenMessage<GetBusinessProfileRequest, {jsonType: GetBusinessProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 2);

/**
 * @generated from message guardianai.v1.caption.BusinessProfileResponse
 */
export type BusinessProfileResponse = Message<"guardianai.v1.caption.BusinessProfileResponse"> & {
  /**
   * @generated from field: guardianai.v1.caption.BusinessProfile profile = 1;
   */
  profile?: BusinessProfile;
};

/**
 * @generated from message guardianai.v1.caption.BusinessProfileResponse
 */
export type BusinessProfileResponseJson = {
  /**
   * @generated from field: guardianai.v1.caption.BusinessProfile profile = 1;
   */
  profile?: BusinessProfileJson;
};

/**
 * Describes the message guardianai.v1.caption.BusinessProfileResponse.
 * Use `create(BusinessProfileResponseSchema)` to create a new message.
 */
export const BusinessProfileResponseSchema: GenMessage<BusinessProfileResponse, {jsonType: BusinessProfileResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 3);

/**
 * @generated from message guardianai.v1.caption.UpdateBusinessProfileRequest
 */
export type UpdateBusinessProfileRequest = Message<"guardianai.v1.caption.UpdateBusinessProfileRequest"> & {
  /**
   * @generated from field: guardianai.v1.caption.BusinessProfile profile = 1;
   */
  profile?: BusinessProfile;
};

/**
 * @generated from message guardianai.v1.caption.UpdateBusinessProfileRequest
 */
export type UpdateBusinessProfileRequestJson = {
  /**
   * @generated from field: guardianai.v1.caption.BusinessProfile profile = 1;
   */
  profile?: BusinessProfileJson;
};

/**
 * Describes the message guardianai.v1.caption.UpdateBusinessProfileRequest.
 * Use `create(UpdateBusinessProfileRequestSchema)` to create a new message.
 */
export const UpdateBusinessProfileRequestSchema: GenMessage<UpdateBusinessProfileRequest, {jsonType: UpdateBusinessProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 4);

/**
 * @generated from message guardianai.v1.caption.GenerateCaptionsRequest
 */
export type GenerateCaptionsRequest = Message<"guardianai.v1.caption.GenerateCaptionsRequest"> & {
  /**
   * @generated from field: repeated string media_webp_base64 = 1;
   */
  mediaWebpBase64: string[];

  /**
   * @generated from field: string user_context = 2;
   */
  userContext: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * @generated from message guardianai.v1.caption.GenerateCaptionsRequest
 */
export type GenerateCaptionsRequestJson = {
  /**
   * @generated from field: repeated string media_webp_base64 = 1;
   */
  mediaWebpBase64?: string[];

  /**
   * @generated from field: string user_context = 2;
   */
  userContext?: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message guardianai.v1.caption.GenerateCaptionsRequest.
 * Use `create(GenerateCaptionsRequestSchema)` to create a new message.
 */
export const GenerateCaptionsRequestSchema: GenMessage<GenerateCaptionsRequest, {jsonType: GenerateCaptionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 5);

/**
 * @generated from message guardianai.v1.caption.GenerateCaptionsResponse
 */
export type GenerateCaptionsResponse = Message<"guardianai.v1.caption.GenerateCaptionsResponse"> & {
  /**
   * @generated from field: string schema_version = 1;
   */
  schemaVersion: string;

  /**
   * @generated from field: string x = 2;
   */
  x: string;

  /**
   * @generated from field: string linkedin = 3;
   */
  linkedin: string;

  /**
   * @generated from field: string instagram = 4;
   */
  instagram: string;

  /**
   * @generated from field: string facebook = 5;
   */
  facebook: string;

  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 6;
   */
  quota?: CaptionQuotaUsage;
};

/**
 * @generated from message guardianai.v1.caption.GenerateCaptionsResponse
 */
export type GenerateCaptionsResponseJson = {
  /**
   * @generated from field: string schema_version = 1;
   */
  schemaVersion?: string;

  /**
   * @generated from field: string x = 2;
   */
  x?: string;

  /**
   * @generated from field: string linkedin = 3;
   */
  linkedin?: string;

  /**
   * @generated from field: string instagram = 4;
   */
  instagram?: string;

  /**
   * @generated from field: string facebook = 5;
   */
  facebook?: string;

  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 6;
   */
  quota?: CaptionQuotaUsageJson;
};

/**
 * Describes the message guardianai.v1.caption.GenerateCaptionsResponse.
 * Use `create(GenerateCaptionsResponseSchema)` to create a new message.
 */
export const GenerateCaptionsResponseSchema: GenMessage<GenerateCaptionsResponse, {jsonType: GenerateCaptionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 6);

/**
 * @generated from message guardianai.v1.caption.GetCaptionQuotaUsageRequest
 */
export type GetCaptionQuotaUsageRequest = Message<"guardianai.v1.caption.GetCaptionQuotaUsageRequest"> & {
  /**
   * @generated from field: optional string user_id = 1;
   */
  userId?: string;
};

/**
 * @generated from message guardianai.v1.caption.GetCaptionQuotaUsageRequest
 */
export type GetCaptionQuotaUsageRequestJson = {
  /**
   * @generated from field: optional string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.caption.GetCaptionQuotaUsageRequest.
 * Use `create(GetCaptionQuotaUsageRequestSchema)` to create a new message.
 */
export const GetCaptionQuotaUsageRequestSchema: GenMessage<GetCaptionQuotaUsageRequest, {jsonType: GetCaptionQuotaUsageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 7);

/**
 * @generated from message guardianai.v1.caption.GetCaptionQuotaUsageResponse
 */
export type GetCaptionQuotaUsageResponse = Message<"guardianai.v1.caption.GetCaptionQuotaUsageResponse"> & {
  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 1;
   */
  quota?: CaptionQuotaUsage;
};

/**
 * @generated from message guardianai.v1.caption.GetCaptionQuotaUsageResponse
 */
export type GetCaptionQuotaUsageResponseJson = {
  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 1;
   */
  quota?: CaptionQuotaUsageJson;
};

/**
 * Describes the message guardianai.v1.caption.GetCaptionQuotaUsageResponse.
 * Use `create(GetCaptionQuotaUsageResponseSchema)` to create a new message.
 */
export const GetCaptionQuotaUsageResponseSchema: GenMessage<GetCaptionQuotaUsageResponse, {jsonType: GetCaptionQuotaUsageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 8);

/**
 * @generated from message guardianai.v1.caption.AdminResetCaptionQuotaRequest
 */
export type AdminResetCaptionQuotaRequest = Message<"guardianai.v1.caption.AdminResetCaptionQuotaRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 daily_quota_override = 2;
   */
  dailyQuotaOverride: number;
};

/**
 * @generated from message guardianai.v1.caption.AdminResetCaptionQuotaRequest
 */
export type AdminResetCaptionQuotaRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 daily_quota_override = 2;
   */
  dailyQuotaOverride?: number;
};

/**
 * Describes the message guardianai.v1.caption.AdminResetCaptionQuotaRequest.
 * Use `create(AdminResetCaptionQuotaRequestSchema)` to create a new message.
 */
export const AdminResetCaptionQuotaRequestSchema: GenMessage<AdminResetCaptionQuotaRequest, {jsonType: AdminResetCaptionQuotaRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 9);

/**
 * @generated from message guardianai.v1.caption.AdminResetCaptionQuotaResponse
 */
export type AdminResetCaptionQuotaResponse = Message<"guardianai.v1.caption.AdminResetCaptionQuotaResponse"> & {
  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 1;
   */
  quota?: CaptionQuotaUsage;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.caption.AdminResetCaptionQuotaResponse
 */
export type AdminResetCaptionQuotaResponseJson = {
  /**
   * @generated from field: guardianai.v1.caption.CaptionQuotaUsage quota = 1;
   */
  quota?: CaptionQuotaUsageJson;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.caption.AdminResetCaptionQuotaResponse.
 * Use `create(AdminResetCaptionQuotaResponseSchema)` to create a new message.
 */
export const AdminResetCaptionQuotaResponseSchema: GenMessage<AdminResetCaptionQuotaResponse, {jsonType: AdminResetCaptionQuotaResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 10);

/**
 * @generated from message guardianai.v1.caption.GetCaptionObservabilityRequest
 */
export type GetCaptionObservabilityRequest = Message<"guardianai.v1.caption.GetCaptionObservabilityRequest"> & {
};

/**
 * @generated from message guardianai.v1.caption.GetCaptionObservabilityRequest
 */
export type GetCaptionObservabilityRequestJson = {
};

/**
 * Describes the message guardianai.v1.caption.GetCaptionObservabilityRequest.
 * Use `create(GetCaptionObservabilityRequestSchema)` to create a new message.
 */
export const GetCaptionObservabilityRequestSchema: GenMessage<GetCaptionObservabilityRequest, {jsonType: GetCaptionObservabilityRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 11);

/**
 * @generated from message guardianai.v1.caption.CaptionObservability
 */
export type CaptionObservability = Message<"guardianai.v1.caption.CaptionObservability"> & {
  /**
   * @generated from field: int64 generations_today_utc = 1;
   */
  generationsTodayUtc: bigint;

  /**
   * @generated from field: int64 generations_last_24h = 2;
   */
  generationsLast24h: bigint;

  /**
   * @generated from field: int64 active_users_last_24h = 3;
   */
  activeUsersLast24h: bigint;

  /**
   * @generated from field: int64 quota_exceeded_last_24h = 4;
   */
  quotaExceededLast24h: bigint;

  /**
   * @generated from field: double avg_latency_ms_last_24h = 5;
   */
  avgLatencyMsLast24h: number;

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt: string;
};

/**
 * @generated from message guardianai.v1.caption.CaptionObservability
 */
export type CaptionObservabilityJson = {
  /**
   * @generated from field: int64 generations_today_utc = 1;
   */
  generationsTodayUtc?: string;

  /**
   * @generated from field: int64 generations_last_24h = 2;
   */
  generationsLast24h?: string;

  /**
   * @generated from field: int64 active_users_last_24h = 3;
   */
  activeUsersLast24h?: string;

  /**
   * @generated from field: int64 quota_exceeded_last_24h = 4;
   */
  quotaExceededLast24h?: string;

  /**
   * @generated from field: double avg_latency_ms_last_24h = 5;
   */
  avgLatencyMsLast24h?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt?: string;
};

/**
 * Describes the message guardianai.v1.caption.CaptionObservability.
 * Use `create(CaptionObservabilitySchema)` to create a new message.
 */
export const CaptionObservabilitySchema: GenMessage<CaptionObservability, {jsonType: CaptionObservabilityJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 12);

/**
 * @generated from message guardianai.v1.caption.GetCaptionObservabilityResponse
 */
export type GetCaptionObservabilityResponse = Message<"guardianai.v1.caption.GetCaptionObservabilityResponse"> & {
  /**
   * @generated from field: guardianai.v1.caption.CaptionObservability observability = 1;
   */
  observability?: CaptionObservability;
};

/**
 * @generated from message guardianai.v1.caption.GetCaptionObservabilityResponse
 */
export type GetCaptionObservabilityResponseJson = {
  /**
   * @generated from field: guardianai.v1.caption.CaptionObservability observability = 1;
   */
  observability?: CaptionObservabilityJson;
};

/**
 * Describes the message guardianai.v1.caption.GetCaptionObservabilityResponse.
 * Use `create(GetCaptionObservabilityResponseSchema)` to create a new message.
 */
export const GetCaptionObservabilityResponseSchema: GenMessage<GetCaptionObservabilityResponse, {jsonType: GetCaptionObservabilityResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_caption_caption, 13);

/**
 * @generated from service guardianai.v1.caption.CaptionService
 */
export const CaptionService: GenService<{
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.GetBusinessProfile
   */
  getBusinessProfile: {
    methodKind: "unary";
    input: typeof GetBusinessProfileRequestSchema;
    output: typeof BusinessProfileResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.UpdateBusinessProfile
   */
  updateBusinessProfile: {
    methodKind: "unary";
    input: typeof UpdateBusinessProfileRequestSchema;
    output: typeof BusinessProfileResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.GenerateCaptions
   */
  generateCaptions: {
    methodKind: "unary";
    input: typeof GenerateCaptionsRequestSchema;
    output: typeof GenerateCaptionsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.GetCaptionQuotaUsage
   */
  getCaptionQuotaUsage: {
    methodKind: "unary";
    input: typeof GetCaptionQuotaUsageRequestSchema;
    output: typeof GetCaptionQuotaUsageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.AdminResetCaptionQuota
   */
  adminResetCaptionQuota: {
    methodKind: "unary";
    input: typeof AdminResetCaptionQuotaRequestSchema;
    output: typeof AdminResetCaptionQuotaResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.caption.CaptionService.GetCaptionObservability
   */
  getCaptionObservability: {
    methodKind: "unary";
    input: typeof GetCaptionObservabilityRequestSchema;
    output: typeof GetCaptionObservabilityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_caption_caption, 0);

